import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import fp from 'lodash/fp';
import styled from 'styled-components';
import { color, mapState } from '@deerplusofficial/pos-helper';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { ButtonBase, Icon } from '@deerplusofficial/pos-components';
import actions from '../../actions';
import { withCancelPreOrder } from '../../model/Mutations';

const timezone = moment.tz.guess();

const Container = styled.div`
  position: relative;
`;

const ItemInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: solid 1px ${color.border};
  &:hover {
    background-color: ${color.background.light};
  }
`;

const Description = styled.div`
  text-align: left;
  color: ${color.text.secondary};
  font-size: 12px;
`;

const Time = styled.time`
  font-size: 12px;
`;

const CancelButton = styled(ButtonBase)`
  color: ${color.error};
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateX(100%) translateY(-50%);
  opacity: 0;
  transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
  ${Container}:hover & {
    opacity: 1;
    transform: translateY(-50%);
  }
`;

class CartPreOrderListItem extends React.PureComponent {
  static propTypes = {
    id: PropTypes.string,
    preOrder: PropTypes.shape(),
  };

  static defaultProps = {
    id: '',
    preOrder: {},
  };

  onCancelClick = () => {
    const {
      id,
      onPreOrderCancel,
      updateList,
      preOrder: { list },
    } = this.props;
    updateList(_.filter(list, item => item.id !== id));
    onPreOrderCancel(id);
  };

  onItemClick = () => {
    const {
      id,
      recoverCart,
      updateCustomPrice,
      updateDiscount,
      updateDetail,
      toggleList,
    } = this.props;
    const { name, description } = this.detail;
    const {
      cart: { items },
      order: { discount, customPrice },
    } = JSON.parse(this.detail.meta);
    recoverCart(items);
    updateCustomPrice(customPrice);
    updateDiscount(discount);
    updateDetail({ id, name, description });
    toggleList();
  };

  get detail() {
    const {
      id,
      preOrder: { list },
    } = this.props;

    return _.find(list, { id });
  }

  render() {
    const { name, description, time } = this.detail;

    return (
      <Container>
        <ButtonBase full onClick={this.onItemClick}>
          <ItemInner>
            <div>
              <div>{name}</div>
              <Description>{description}</Description>
            </div>
            <Time>
              {moment
                .utc(time)
                .tz(timezone)
                .format('HH:mm')}
            </Time>
          </ItemInner>
        </ButtonBase>
        <CancelButton onClick={this.onCancelClick}>
          <Icon icon="trash-alt" />
        </CancelButton>
      </Container>
    );
  }
}

const { recover: recoverCart } = actions.cart;
const {
  customPrice: { edit: updateCustomPrice },
  discount: { edit: updateDiscount },
} = actions.order;
const {
  list: { toggle: toggleList, update: updateList },
  detail: { update: updateDetail },
} = actions.preOrder;

export default fp.compose(
  withCancelPreOrder(),
  connect(
    mapState(['preOrder']),
    {
      recoverCart,
      updateCustomPrice,
      updateDiscount,
      toggleList,
      updateList,
      updateDetail,
    }
  )
)(CartPreOrderListItem);



// WEBPACK FOOTER //
// ./src/components/Cart/CartPreOrderListItem.js